import React from "react"

// Img
import imgShirai from "../../assets/img/logo_shirai.png"

const LogoShirai = () => {
  return <img src={imgShirai} alt="株式会社 白井設計" />
}

export default LogoShirai